<template>
    <div class="sign-loading" v-if="posting"
        :style="{ 'backgroundColor': bgColor, 'position': position, 'margin-top': top }">
        <img :src="loadingImg[imgIndex + 1].url" alt="" />
    </div>
</template>

<script>
export default {
    props: ['bgColor', 'position', 'top'],
    data() {
        return {
            loadingImg: [
                { url: require("@/assets/images/loading_dog_01.png") },
                { url: require("@/assets/images/loading_dog_02.png") },
                { url: require("@/assets/images/loading_dog_03.png") },
                { url: require("@/assets/images/loading_dog_04.png") },
                { url: require("@/assets/images/loading_dog_05.png") },
                { url: require("@/assets/images/loading_dog_06.png") },
            ],
            imgIndex: 1,
            posting: false
        }
    },
    mounted() {
        this.loading()
    },
    methods: {
        loading() {
            this.posting = true
            var count = 0
            let loadtimer = setInterval(() => {
             

                this.imgIndex = this.imgIndex + 1;
                if (this.imgIndex >= 5) {
                    this.imgIndex = 0;
                }
                if (this.posting == false) {
                    window.clearInterval(loadtimer);
                }
            }, 1000 / 12);
        },
        close() {
            this.posting = false
        },
    }
}
</script>
<style lang="scss" scoped>
.sign-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    // border-radius: 48px;

    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    img {
        scale: .7;
    }
}
</style>